import baseAPI from '@/api';
import { LuckySpinRewards } from '@/models/userReward/lucky-spin/lucky-spin-rewards';
import { SpinRequestDto } from '@/services/dto/lucky-spins/spin-request.dto';

export async function fetchSpin({ luckySpinId }: SpinRequestDto) {
  const response = await baseAPI.post<LuckySpinRewards>('/lucky-spins/spin', {
    luckySpinId,
  });

  return response.data;
}
